import {HoneypotFieldParams} from "./honeypot-field-params";

export interface VerificationChallengeSubmitParams {
  startSolvingTimestamp: string;
  solvedTimestamp: string;
  tasks: ChallengeNonceParams[];
  honeypotFields: HoneypotFieldParams[];
  userEvents: any[];
}

export interface ChallengeNonceParams {
  number: number;
  nonce: string;
}
